module.exports = __webpack_public_path__ + "img/32.05a14c74.svg";